const SalesTarget = {

    // FIELDS
    "division": "القسم",
    "sales_person": "مندوب المبيعات",
    "financial_year": "السنة المالية",
    "quarter1": "الربع 1",
    "quarter2": "الربع 2",
    "quarter3": "الربع 3",
    "quarter4": "الربع 4",
    "total": "المجموع",
    "fy_sale": "مبيعات السنة المالية السابقة",
    "category": "الفئة",
    "sub_category": "الفئة الفرعية",
    "search": "بحث",

    // PAGE HEADER
    "sales_target": "هدف المبيعات",

    // SWEET ALERT
    "sales_person_not_found": "مندوب المبيعات غير موجود",
    "select_sales_person": "اختر مندوب المبيعات",

    // ERROR
    "error_division": "اختر القسم",
    "error_sales_person": "اختر مندوب المبيعات",
    "error_financial_year": "اختر السنة المالية",
    "error_category": "الفئة غير موجودة",
    "error_target_amount_q1": "أدخل المبلغ",
    "error_target_amount_q2": "أدخل المبلغ",
    "error_target_amount_q3": "أدخل المبلغ",
    "error_target_amount_q4": "أدخل المبلغ",
    "error_positive_no": "لا يمكن أن يكون سالبًا",

    // TABLE HEADER
    "table_sales_person": "مندوب المبيعات",
    "table_division": "القسم",
    "table_fy": "السنة المالية",
}

export default SalesTarget;